var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1C1C1A",
  fillRule: "evenodd",
  d: "M.146 3.646a.5.5 0 0 1 .708 0L8 10.793l7.146-7.147a.5.5 0 0 1 .708.708L8 12.207.146 4.354a.5.5 0 0 1 0-.708",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export { SvgChevronDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzc0Ml8xMDM4OSkiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAuMTQ2NDQ3IDMuNjQ2NDVDMC4zNDE3MDkgMy40NTExOCAwLjY1ODI5MSAzLjQ1MTE4IDAuODUzNTUzIDMuNjQ2NDVMOCAxMC43OTI5TDE1LjE0NjQgMy42NDY0NUMxNS4zNDE3IDMuNDUxMTggMTUuNjU4MyAzLjQ1MTE4IDE1Ljg1MzYgMy42NDY0NUMxNi4wNDg4IDMuODQxNzEgMTYuMDQ4OCA0LjE1ODI5IDE1Ljg1MzYgNC4zNTM1NUw4IDEyLjIwNzFMMC4xNDY0NDcgNC4zNTM1NUMtMC4wNDg4MTU1IDQuMTU4MjkgLTAuMDQ4ODE1NSAzLjg0MTcxIDAuMTQ2NDQ3IDMuNjQ2NDVaIiBmaWxsPSIjMUMxQzFBIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNzQyXzEwMzg5Ij4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";